import React, { useEffect, useMemo, useState } from 'react';
import { Button, Typography, Card, Flex, Form, Slider, Select, Modal, Upload, Tabs, Space, Input, DatePicker, Divider, Col, Row, Tooltip, Empty } from 'antd';
import PageHeader from '../../view/pageheader';
import { DownloadOutlined, PlusOutlined, SaveOutlined, UploadOutlined, PrinterOutlined, ReloadOutlined, ScanOutlined, SearchOutlined, EditOutlined, RightOutlined, DeleteColumnOutlined, DeleteOutlined, EyeFilled } from '@ant-design/icons';
import { updateWeareHouseData, weareHouseById, specAssignedBoxes, uploadWeareHouseData, clearWareHouseyIdData, clearCompletedWareHouseByIdData, awaitingReviewBoxes, deleteBoxUniqueIDWeareHouseData } from "../../store/reducer/wearehouseSlice";
import { getJobsList } from "../../store/reducer/jobSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify'
import { addFileType, FileAllType, getDeletedBoxUniqueID } from '../../store/reducer/prepQueueSlice';
import TableComponent from '../CustomComponents/TableComponent';
import { getCustomerList } from "../../store/reducer/customerSlice";
import moment from 'moment';
import SearchComponent from '../CustomComponents/SearchComponent';
import dayjs from 'dayjs';
import TextArea from 'antd/es/input/TextArea';
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useRef } from 'react';
import Loader from '../../fields/Loader/Loader';
import Swal from 'sweetalert2';
const { Title, Text } = Typography;
const { TabPane } = Tabs;
const ReviewAndAssignSpec = () => {
    const params = useParams();
    const id = params.all;
    const location = useLocation();
    const params1 = new URLSearchParams(location.search);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [form] = Form.useForm();
    const getQueryParams = () => {
        const params = new URLSearchParams(location.search);
        return {
            query: params.get("query") || "",
        };
    };
    const [preprocessingQueueData, setPreprocessingQueueData] = useState([]);
    const [completedPreprocessingQueueData, setCompletedPreprocessingQueueData] = useState([]);
    console.log(completedPreprocessingQueueData, "completedPreprocessingQueueData==");

    const [completedOrginalData, setCompletedOrginalData] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [jobData, setJobData] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const { awaitingReviewBoxesData, specAssignedBoxesData, weareHouseLoading, deleteBoxUniqueIDWeareHouseDataSuccess } = useSelector((state) => state.wearehouse);
    const { customerListData } = useSelector((state) => state.customers);
    const { AllFileData, getDeletedBoxUniqueIDData } = useSelector((state) => state.prepTeamQueue);
    const { jobListData } = useSelector((state) => state.jobs);
    const { count: deletedCounts, data: deletedTableData } = getDeletedBoxUniqueIDData;
    const userId = localStorage.getItem('user_id');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [fileList, setFileList] = useState([]);
    const [uploadModalVisible, setUploadModalVisible] = useState(false);
    const [modifiedRows, setModifiedRows] = useState(new Set());
    const [fileData, setFileData] = useState([])
    const [activetab, setActiveTab] = useState("1")
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchText, setSearchText] = useState('');
    const [barocdestartvalue, setBarocdestartvalue] = useState('');
    const [barocdeendvalue, setBarocdeendvalue] = useState('');
    const [uniqueIdStartValue, setUniqueIdStartValue] = useState('');
    const [uniqueIdEndValue, setUniqueIdEndValue] = useState('');
    const [pendingPayload, setPendingPayload] = useState(null);
    const [searchModal, setSearchModal] = useState(false)
    const [clearData, setClearData] = useState(false);
    const [fileModal, setFileModal] = useState(false)
    const [addFileMOdal, setAddFileModal] = useState(false)
    const [editingFileType, setEditingFileType] = useState(null);
    const [isEditingFile, setIsEditingFile] = useState(false);
    const [searchDate, setSearchDate] = useState(null);
    const [isProcessModalOpen, setIsProcessModalOpen] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState(null);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    console.log(selectedRecord, "selectedRecord==");

    const {
        control: fileControl,
        setValue: setFileValue,
        handleSubmit: handleFileSubmit,
        formState: { errors: fileErrors },
        reset: rest
    } = useForm({
        resolver: yupResolver(yup.object().shape({
            file_type: yup.string().trim().required("File Type is required")
        })),
        mode: "onChange",
    });
    const { count: counts, data: tableFileData } = AllFileData
    function getAllData(payload = {}) {
        dispatch(getJobsList(payload))
        dispatch(FileAllType(payload))
        dispatch(getCustomerList(payload))
        dispatch(getDeletedBoxUniqueID({ editId: atob(id) }))

    }
    function getData(payload = {}) {
        const query = payload.query || '';
        const pickup_date = payload.pickup_date;
        if (id) {
            getAllData()
            const editId = window.atob(id);
            const assign_user_id = localStorage.getItem('user_id');

            //   dispatch(clearCompletedBox());
            //   dispatch(clearnotCompletedBox());
            if (activetab == '1') {

                dispatch(awaitingReviewBoxes({ editId, query, pickup_date, ...payload }));

            }
            else if (activetab == '2') {
                dispatch(specAssignedBoxes({ editId, query, pickup_date, assign_user_id, payload }));
            }

        }

    }
    const handleAddFileClose = () => {
        setAddFileModal(false);
        setEditingFileType(null);
        setIsEditingFile(false);
        rest();
    }
    useEffect(() => {
        if (id && activetab && pendingPayload !== null) {
            getData(pendingPayload);
        }
    }, [id, activetab, pendingPayload]);
    useEffect(() => {
        const { query } = getQueryParams();

        const payload = {};
        if (query && query.trim() !== "") {
            setSearchText(query.trim());
            payload.query = query.trim();
        }

        // if (pickup_date) {
        //     setSearchDate(pickup_date); // keep as string if backend expects MM/DD/YYYY
        //     payload.pickup_date = pickup_date;
        // }

        if (payload.query) {
            setPendingPayload(payload);
            setActiveTab("2");
        } else {
            setPendingPayload({});
            // setActiveTab(id === "all" ? "2" : "1");
        }
    }, [id, location.search]);
    useEffect(() => {
        let formattedData1 = [];
        if (activetab == '1' && Array.isArray(awaitingReviewBoxesData?.data)) {

            formattedData1 = awaitingReviewBoxesData?.data.map((item, index) => ({
                ...item,
                key: index.toString(),
            }));
        }

        if (formattedData1.length > 0) {
            setPreprocessingQueueData(formattedData1);
            setOriginalData(JSON.stringify(formattedData1));
        }
        if (jobListData?.data) {
            setJobData(jobListData.data);
        }

        if (AllFileData?.data) {
            setFileData(AllFileData.data);
        }

        if (customerListData?.data) {
            setCustomerList(customerListData.data);
        }
    }, [awaitingReviewBoxesData, jobListData, AllFileData, customerListData, activetab]);

    useEffect(() => {
        let formattedData2 = [];
        if (activetab == '2' && Array.isArray(specAssignedBoxesData?.data)) {
            formattedData2 = specAssignedBoxesData?.data.map((item, index) => ({
                ...item,
                key: index.toString(),
            }));
        }
        if (formattedData2.length > 0) {
            setCompletedPreprocessingQueueData(formattedData2);
            setCompletedOrginalData(JSON.stringify(formattedData2));
        }
    }, [specAssignedBoxesData, activetab]);
    const specIdData = useMemo(() => {
        if (!preprocessingQueueData.length || !jobData.length) return [];
        return jobData
            .map((item) => ({
                label: item?.spec_id,
                value: item?.id,
                workflow_id: item?.workflow_id,
                customer_id: item?.customer_id,
                customer_name: item?.customer?.customername
            }));
    }, [jobData, preprocessingQueueData]);

    const customerLists = useMemo(() => {
        if (!customerList.length) return [];
        return customerList
            .filter((customer) => customer.status == 1)
            .map((item) => ({
                label: item.customername,
                value: item.id,
            }));
    }, [customerList]);
    const fileDatas = useMemo(() => {

        return fileData
            .map((item) => ({
                label: item?.file_type,
                value: item?.id,

            }));
    }, [fileData]);
    const onSubmitFile = (data) => {
        const payload = {
            postData: {
                file_type: data.file_type,
                ...(isEditingFile && { id: editingFileType.id }) // Include ID if editing
            }
        };
        dispatch(addFileType({ postData: payload }))
            .then(() => {
                // toast.success(`FileType ${isEditingFile ? 'Updated' : 'Added'} Successfully`);
                handleAddFileClose();
                rest();
                setEditingFileType(null);
                setIsEditingFile(false);
            });
    };
    const handleSearchFilter = () => {
        const payloadData = {
            query: searchText,
        };


        // Add pickup_date only if selected
        if (searchDate) {
            payloadData.pickup_date = dayjs(searchDate).format('MM/DD/YYYY'); // send in MM/DD/YYYY format
        }
        getData(payloadData);
        setSearchModal(false)
        setSearchDate(null)
        setSearchText('');

    };
    const handleSearch = () => {
        const payloadData = {
            query: searchText,
        };

        // Add pickup_date only if selected
        if (searchDate) {
            payloadData.pickup_date = dayjs(searchDate).format('MM/DD/YYYY'); // send in MM/DD/YYYY format
        }
        getData(payloadData);
        setSearchModal(false)
        setSearchDate(null)
        setSearchText('');
        setClearData(true)

    };
    const handleDownloadExcel = () => {
        // Main sheet data
        let tableData = [];
        if (activetab == '1') {
            // Main Preprocessing Queue data
            tableData = preprocessingQueueData.map(
                ({
                    box_unique_id, customer_name, spec, from, to,
                    printed_name, date_in, description, series_box, loc, building, aisle,
                    level, shelf
                }) => ({
                    'Unique ID': box_unique_id,
                    'Customer Name': customer_name,
                    'Spec ID': spec,
                    'From': from,
                    'To': to,
                    'Label Printed Name/Date': printed_name,
                    'Date In (mm/dd/yyyy)': date_in ? moment(date_in).format("MM/DD/YYYY") : null,
                    'Description': description,
                    'Series Box': series_box,
                    'Loc': loc,
                    'Building or Address': building,
                    'Aisle': aisle,
                    'Level': level,
                    'Shelf': shelf
                })
            );
        } else {
            // Completed Preprocessing Queue data
            tableData = completedPreprocessingQueueData.map(
                ({
                    box_unique_id, from, to,
                    printed_name, date_in, description, series_box, loc, building, aisle,
                    level, shelf
                }) => ({
                    'Unique ID': box_unique_id,
                    'From': from,
                    'To': to,
                    'Label Printed Name/Date': printed_name,
                    'Date In (mm/dd/yyyy)': date_in ? moment(date_in).format("MM/DD/YYYY") : null,
                    'Description': description,
                    'Series Box': series_box,
                    'Loc': loc,
                    'Building or Address': building,
                    'Aisle': aisle,
                    'Level': level,
                    'Shelf': shelf
                })
            );
        }

        // --- Reference Sheet Setup (Customer Name + Spec ID) ---
        const referenceSheetData = [['Customer Name', 'Spec ID']]; // headers

        specIdData.forEach(specItem => {
            const customerName = specItem.customer_name || '';
            const specId = Number(specItem.label) || '';
            referenceSheetData.push([customerName, specId]);
        });

        // --- Excel sheet creation ---
        const ws1 = XLSX.utils.json_to_sheet(tableData);
        const ws2 = XLSX.utils.aoa_to_sheet(referenceSheetData);

        // Set column widths
        const colWidth1 = 25;
        ws1['!cols'] = Object.keys(tableData[0] || {}).map(() => ({ wch: colWidth1 }));

        const colWidth2 = 30;
        ws2['!cols'] = referenceSheetData[0].map(() => ({ wch: colWidth2 }));

        // Workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws1, 'Preprocessing Queue');
        XLSX.utils.book_append_sheet(wb, ws2, 'Reference Sheet');

        // Export
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'WareHouse.xlsx');
    };


    const handleDownloadUniqueIDLabel = () => {


        if (selectedRowKeys.length == 0) {
            toast.error("Please select at least one row to download the barcode Excel file.");
            return;
        }
        const tableData = selectedRowKeys.map(
            ({
                box_unique_id
            }) => ({

                'Unique ID': box_unique_id,
            })
        );

        // Create headers
        const combinedSheetData = [['Allowed Spec Id', 'All File Types']];

        // Get max length to iterate safely
        const maxLength = Math.max(specIdData.length, fileDatas.length, customerLists.length);

        const customerMap = {};
        customerList.forEach(customer => {
            customerMap[customer.id] = customer.customername;
        });

        // Generate the combined data
        for (let i = 0; i < maxLength; i++) {
            const specId = specIdData[i]?.label ?? '';
            const customerId = specIdData[i]?.customer_name ?? '';
            const fileType = fileDatas[i]?.label ?? '';

            const customerName = customerMap[customerId] || '';
            const specWithCustomer = specId ? `${specId} - ${customerId}` : '';

            combinedSheetData.push([specWithCustomer, fileType || '']);
        }

        const ws1 = XLSX.utils.json_to_sheet(tableData);
        const ws2 = XLSX.utils.aoa_to_sheet(combinedSheetData);
        const colWidth1 = 25;
        ws1['!cols'] = Object.keys(tableData[0] || {}).map(() => ({ wch: colWidth1 }));
        const colWidth2 = 30;
        ws2['!cols'] = combinedSheetData[0].map(() => ({ wch: colWidth2 }));
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws1, 'Unique ID Labels');
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        saveAs(data, 'export_unique_id_label.xlsx');
        const postData = {
            updatedData: selectedRowKeys.map((data) => ({
                box_unique_id: data.box_unique_id,
                is_printed: 1,
            })),
        };

    };
    const excelDateToJSDate = (serial) => {
        const utc_days = Math.floor(serial - 25569);
        const utc_value = utc_days * 86400; // seconds in a day
        const date_info = new Date(utc_value * 1000); // convert to ms
        return moment(date_info).format("MM/DD/YYYY");
    };

    const role_id = localStorage.getItem("role_id");
    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setFileList([]);
    };

    const handleUpload = async () => {


        const allowedExtensions = ["xlsx", "xls", "xlsm", "xltx", "ods", "xlsb"];
        if (!fileList.length) {
            toast.error("Please select an Excel file to upload!");
            return;
        }

        const file = fileList[0];
        const fileName = file.name;

        const fileExtension = file.name.split(".").pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
            toast.error("Invalid file type! Please upload a valid Excel file.");
            return;
        }
        const reader = new FileReader();

        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });

            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];
            const jsonData = XLSX.utils.sheet_to_json(sheet)

            // const allowedSpecIds = specIdData.map((item) => item.label);
            let hasErrors = false;
            // const allSpecIdsEmpty = jsonData.every(row => row["Spec ID"] === null || row["Spec ID"] === undefined);
            // if (allSpecIdsEmpty) {
            //   toast.error("All spec IDs is Empty");
            //   hasErrors = true;
            // }
            if (
                jsonData.length >
                (activetab == '1' ? preprocessingQueueData.length : completedPreprocessingQueueData.length)
            ) {
                toast.error("You have uploaded more records than allowed!");
                hasErrors = true;
            }


            jsonData.forEach((row, index) => {
                if (!row["Unique ID"]) {
                    toast.error(`Row ${index + 1}: Missing required fields.`);
                    hasErrors = true;
                }
                if (row["Date In (mm/dd/yyyy)"] && typeof row["Date In (mm/dd/yyyy)"] == "number") {
                    row["Date In (mm/dd/yyyy)"] = excelDateToJSDate(row["Date In (mm/dd/yyyy)"]);
                }


            });

            jsonData.includes(jsonData)

            if (!hasErrors) {
                const specWorkflowMap = specIdData.reduce((map, item) => {
                    map[item.label] = item.workflow_id;
                    return map;
                }, {});
                const processingMap = {};
                preprocessingQueueData.forEach(item => {
                    processingMap[item.box_unique_id] = item.processing_id;
                });

                // Add workflow_id to each row in jsonData
                const processedData = jsonData.map(row => ({
                    ...row,
                    workflow_id: row["Spec ID"] ? specWorkflowMap[row["Spec ID"]] : null,
                    processing_id: processingMap[row["Unique ID"]] || null,
                }));
                const postData = {
                    jsonData: processedData,
                    assign_user_id: userId,
                    prep_queue_id: atob(id),
                    updated_user_id: Number(localStorage.getItem('user_id')),
                    activetab: activetab,
                    file_name: fileName,
                }
                dispatch(uploadWeareHouseData({ postData }))
                setFileList([]);
                setUploadModalVisible(true);
                setIsModalOpen(false)
                // toast.success("Excel file uploaded successfully!");
                // navigate(`/upload-log`);

            }
        };

        reader.readAsArrayBuffer(file);
    };
    useEffect(() => {
        if (id) {
            try {
                const editId = window.atob(id)
                const assign_user_id = localStorage.getItem("user_id");

                if (assign_user_id) {
                    //   dispatch(prepQueueById({ editId, assign_user_id }));
                    // toast.success("Excel Prep Process Success");
                    setIsModalOpen(false);
                } else {
                    console.error("User ID not found in localStorage");
                }
            } catch (error) {
                console.error("Invalid base64 ID:", error);
            }
        }

        // if (addExcelPrepProcessError) {
        //   toast.error(addExcelPrepProcessErrorMessage || "An error occurred.");
        //   dispatch(resetSuccessFlag({ flag: "addExcelPrepProcessError" }));
        // }
    }, [dispatch, id, setIsModalOpen]);
    // const disabledData=preprocessingQueueData.filter((data)=>data.allocated==1)

    useEffect(() => {
        if (deleteBoxUniqueIDWeareHouseDataSuccess) {
            toast.success("Unique ID Deleted Successfully")
            getData({})
        }
    }, [deleteBoxUniqueIDWeareHouseDataSuccess])

    const columns = [
        {
            title: 'Unique ID',
            key: 'box_unique_id',
            fixed: 'left',
            width: '25%',
            render: (_, record) => {
                // CASE 1: if record moved
                if (record.is_moved == 1) {
                    return (
                        <span style={{ color: 'red' }}>
                            {record.box_unique_id} — This moved to {record.moved_spec}
                        </span>
                    );
                }

                // CASE 2: if tab == 2 and disposition completed
                if (activetab == 2 && record.box_status === "Dispositon Completed") {
                    return (
                        <>
                            <span>
                                {record.box_unique_id} — </span> <span style={{ color: 'green', fontSize: 10 }}>Disposition Completed  </span>
                        </>

                    );
                }

                // CASE 3: default clickable blue text
                return (
                    <span
                        style={{ color: 'blue', cursor: 'pointer' }}
                        onClick={() => {
                            setSelectedRecord(record); // set current row
                            setIsProcessModalOpen(true); // open modal
                        }}
                    >
                        {record.box_unique_id}
                    </span>
                );
            },
        },

        {
            title: 'Customer Name',
            dataIndex: 'customer_name',
            key: 'customer_name',
            fixed: 'left',
            width: '40%',

            render: (text, record) => (

                <>

                    <Select

                        style={{ width: '100%' }}
                        options={customerLists}
                        value={record.customer_name}
                        placeholder='Select Customers Name'
                        disabled={record.is_moved == 1 || record?.is_saved == 1}
                        onChange={(value) => {
                            const selectedCustomer = customerLists.find((item) => item.value === value);
                            const newData = [...preprocessingQueueData];
                            const index = newData.findIndex((item) => item.key === record.key);

                            if (index > -1) {
                                newData[index] = {
                                    ...record,
                                    customer_id: selectedCustomer?.value || null,
                                    customer_name: selectedCustomer?.label || '',
                                    spec: null,
                                    spec_id: null,
                                    workflow_id: null,
                                };

                                setPreprocessingQueueData(newData);
                                setModifiedRows((prev) => new Set(prev.add(record.key)));
                            }
                        }}
                    />

                </>
            ),
        },
        {
            title: (<span> Spec ID <span style={{ color: 'red' }}>*</span>
            </span>
            ),
            dataIndex: 'spec',
            key: 'spec',
            width: '40%',
            fixed: 'left',
            render: (text, record) => {
                // Dynamically filter spec options based on the current row's customer_id
                const specOptions = jobData
                    .filter((item) => item.customer_id == record.customer_id)
                    .map((item) => ({
                        label: item.spec_id,
                        value: item.id,
                        // workflow_id: item.workflow_id,
                    }));

                return (
                    <Select
                        showSearch
                        style={{ width: '100%' }}
                        options={specOptions}
                        value={record.spec}
                        placeholder='Select Spec ID'
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                            option.label?.toLowerCase().includes(input.toLowerCase())
                        }
                        disabled={record.is_moved == 1 || record?.is_saved == 1}
                        onChange={(value) => {
                            const selectedSpec = specOptions.find((item) => item.value === value);
                            const newData = [...preprocessingQueueData];
                            const index = newData.findIndex((item) => item.key === record.key);
                            if (index > -1) {
                                newData[index] = {
                                    ...record,
                                    spec: selectedSpec.label,
                                    job_id: selectedSpec.value,
                                    workflow_id: selectedSpec.workflow_id,
                                };
                                setPreprocessingQueueData(newData);
                                setModifiedRows((prev) => new Set(prev.add(record.key)));
                            }
                        }}
                    />
                );
            },
        },
        {
            title: 'BOX',
            dataIndex: 'box',
            render: (text, record) => (record?.box >= 1 ? record?.box : '-'),
            key: 'box',
            width: '20%',
        },
        {
            title: 'ALT BOX',
            dataIndex: 'alt_box',
            render: (text, record) => (record?.alt_box >= 0 ? record?.alt_box : '-'),
            key: 'alt_box',
            width: '20%',
        },
        {
            title: 'Scantek Barcode',
            dataIndex: 'barcode',
            render: (text, record) => (record?.barcode ? record?.barcode : '-'),
            key: 'barcode',
            width: '40%',
        },
        {
            title: (<span> From <span style={{ color: 'red' }}>*</span></span>),
            dataIndex: 'from',
            key: 'from',
            width: '40%',
            render: (text, record) => {
                // Enable editing for both tabs 1 and 2
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            style={{ width: '200px' }}
                            value={record.from}
                            disabled={record.is_moved == 1}
                            placeholder="Enter From"
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;
                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, from: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.from}</span>;
                }
            }
        },

        {
            title: (<span> To <span style={{ color: 'red' }}>*</span></span>),
            dataIndex: 'to',
            key: 'to',
            width: '40%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            style={{ width: '200px' }}
                            value={record.to}
                            placeholder="Enter To"
                            disabled={record.is_moved == 1}
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, to: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.to}</span>;
                }
            },
        },
        {
            title: 'LABEL PRINTED NAME/DATE',
            dataIndex: 'printed_name',
            key: 'printed_name',
            width: '80%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            style={{ width: '300px' }}
                            value={record.printed_name}
                            placeholder="Enter Printed Name"
                            disabled={record.is_moved == 1}
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, printed_name: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.printed_name}</span>;
                }
            },
        },
        {
            title: (<span> Box Pickup Date <span style={{ color: 'red' }}></span>
            </span>
            ),
            dataIndex: 'date_in',
            key: 'date_in',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <DatePicker
                            format={"MM/DD/YYYY"}
                            disabled={record.is_moved == 1}
                            style={{ width: '200px' }}
                            value={record.date_in ? dayjs(record.date_in) : null}
                            placeholder="Select Date In"
                            onChange={(date, dateString) => {
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key === record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, date_in: dateString };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows((prev) => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.date_in ? moment(record.date_in).format("MM/DD/YYYY") : '-'}</span>;
                }
            },
            width: '40%',
        },
        {
            title: (<span> DESCRIPTION <span style={{ color: 'red' }}>*</span>
            </span>
            ),
            dataIndex: 'description',
            key: 'description',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <TextArea
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.description}
                            placeholder='Enter Description'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, description: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.description}</span>;
                }
            },
            width: '40%',
        },
        {
            title: 'Series Box',
            dataIndex: 'series_box',
            key: 'series_box',
            width: '40%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.series_box}
                            placeholder='Enter Series Box'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, series_box: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.series_box}</span>;
                }
            },
        },
        {
            title: 'LOC',
            dataIndex: 'loc',
            key: 'loc',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.loc}
                            placeholder='Enter Loc'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, loc: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.loc}</span>;
                }
            },
        },
        {
            title: 'Building or Address',
            dataIndex: 'building',
            key: 'building',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.building}
                            placeholder='Enter Building'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, building: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.building}</span>;
                }
            }
        },
        {
            title: 'Aisle',
            dataIndex: 'aisle',
            key: 'aisle',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.aisle}
                            placeholder='Enter Aisle'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, aisle: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.aisle}</span>;
                }
            },
        },
        {
            title: 'Level',
            dataIndex: 'level',
            key: 'level',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.level}
                            placeholder='Enter Level'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, level: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.level}</span>;
                }
            },
        },
        {
            title: 'Shelf',
            dataIndex: 'shelf',
            key: 'shelf',
            width: '60%',
            render: (text, record) => {
                if (activetab === '1' || activetab === '2') {
                    return (
                        <Input
                            disabled={record.is_moved == 1}
                            style={{ width: '300px' }}
                            value={record.shelf}
                            placeholder='Enter Shelf'
                            onChange={(e) => {
                                const value = e.target.value;
                                let newData;

                                if (activetab === '1') {
                                    newData = [...preprocessingQueueData];
                                } else {
                                    newData = [...completedPreprocessingQueueData];
                                }

                                const index = newData.findIndex((item) => item.key == record.key);
                                if (index > -1) {
                                    newData[index] = { ...record, shelf: value };

                                    if (activetab === '1') {
                                        setPreprocessingQueueData(newData);
                                    } else {
                                        setCompletedPreprocessingQueueData(newData);
                                    }

                                    setModifiedRows(prev => new Set(prev.add(record.key)));
                                }
                            }}
                        />
                    );
                } else {
                    return <span>{record.shelf}</span>;
                }
            },
        }
        ,
        // {
        //     title: 'Left Warehouse',
        //     dataIndex: 'left_warehouse',
        //     key: 'left_warehouse',
        //     width: '60%',
        //     render: (text, record) => (
        //         <Input style={{ width: '300px' }}
        //             value={record.left_warehouse}
        //             placeholder='Enter Building'
        //             // disabled={record.from}
        //             onChange={(e) => {
        //                 const value = e.target.value;
        //                 const newData = [...preprocessingQueueData];
        //                 const index = newData.findIndex((item) => item.key == record.key);
        //                 if (index > -1) {
        //                     newData[index] = { ...record, left_warehouse: value };
        //                     setPreprocessingQueueData(newData);
        //                     setModifiedRows(prev => new Set(prev.add(record.key)));
        //                 }
        //             }}
        //         />
        //     ),
        // }

        // {
        //   title: 'Building or Address',
        //   dataIndex: 'address',
        //   key: 'address',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.address}
        //       placeholder='Enter Address'
        //       // disabled={record.customer_box_id}
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, address: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Aisle',
        //   dataIndex: 'aisle',
        //   key: 'aisle',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.aisle}
        //       placeholder='Enter Aisle'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, aisle: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Level',
        //   dataIndex: 'level',
        //   key: 'level',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.level}
        //       placeholder='Enter Level'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, level: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Bay',
        //   dataIndex: 'bay',
        //   key: 'bay',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.bay}
        //       placeholder='Enter Bay'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, bay: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'From',
        //   dataIndex: 'from',
        //   key: 'from',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <Input style={{ width: '200px' }}
        //       value={record.from}
        //       placeholder='Enter From'
        //       onChange={(e) => {
        //         const value = e.target.value;
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key == record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, from: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Pickup Date',
        //   dataIndex: 'pickup_date',
        //   key: 'pickup_date',
        //   render: (text, record) => (
        //     <DatePicker
        //       format="MM/DD/YYYY"
        //       style={{ width: '200px' }}
        //       value={record.pickup_date ? dayjs(record.pickup_date) : null} // ensure moment object
        //       placeholder="Enter Pickup Date"
        //       onChange={(date) => {
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key === record.key);
        //         if (index > -1) {
        //           newData[index] = {
        //             ...record,
        //             pickup_date: date,
        //           };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows((prev) => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Left Warehouse',
        //   dataIndex: 'left_warehouse',
        //   key: 'left_warehouse',
        //   render: (text, record) => (
        //     <DatePicker
        //       format="MM/DD/YYYY"
        //       style={{ width: '300px' }}
        //       value={record.left_warehouse ? dayjs(record.left_warehouse) : null} // ensure moment object
        //       placeholder="Enter Pickup Date"
        //       onChange={(date) => {
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key === record.key);
        //         if (index > -1) {
        //           newData[index] = {
        //             ...record,
        //             left_warehouse: date,
        //           };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows((prev) => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Original Disposition',
        //   dataIndex: 'original_disposition',
        //   key: 'original_disposition',
        //   // width: '40%',
        //   render: (text, record) => (
        //     <Select
        //       style={{ width: '100%' }}
        //       options={original_dispositionData}
        //       value={record.original_disposition} // this should be the value
        //       placeholder="Select Original Disposition"
        //       onChange={(value,label) => {


        //         const selectedFile = original_dispositionData.find(item => item.value == value);
        //         if (!selectedFile) return;

        //         const updatedData = [...preprocessingQueueData];
        //         const index = updatedData.findIndex(item => item.key === record.key);

        //         if (index !== -1) {
        //           updatedData[index] = {
        //             ...updatedData[index],
        //             original_disposition: selectedFile.label, // store value only
        //           };
        //           setPreprocessingQueueData(updatedData);
        //           setModifiedRows(prev => new Set(prev).add(record.key));
        //         }
        //       }}
        //     />
        //   ),
        // },
        // {
        //   title: 'Disposition Days',
        //   dataIndex: 'disposition_day',
        //   key: 'disposition_day',
        //   // width: '35%',
        //   render: (text, record) => (
        //     <InputNumber style={{ width: '200px' }}
        //       value={record.disposition_day}
        //       placeholder='Enter Disposition Days'
        //       onChange={(value) => {
        //         const newData = [...preprocessingQueueData];
        //         const index = newData.findIndex((item) => item.key === record.key);
        //         if (index > -1) {
        //           newData[index] = { ...record, disposition_day: value };
        //           setPreprocessingQueueData(newData);
        //           setModifiedRows(prev => new Set(prev.add(record.key)));
        //         }
        //       }}
        //     />
        //   ),
        // },


    ];
    const deletedColumns = [
        {
            title: "Unique ID ",
            dataIndex: "box_unique_id",
            key: "box_unique_id",
            align: 'center',
            // width: "80%",
        },
        {
            title: "Barcode",
            dataIndex: "barcode",
            key: "barcode",
            render: (text) => (text ? text : 'N/A'),
            align: 'center',
        },
        {
            title: "Pickup Date",
            dataIndex: "pickup_date",
            key: "pickup_date",
            render: (text) => (text ? text : 'N/A'),
            align: 'center',
        },
        {
            title: "Deleted Date",
            dataIndex: "deleted_at",
            key: "deleted_at",
        },


    ];
    const getAllBarocde = preprocessingQueueData.filter((data) => data.barcode != null).map((item) => ({
        value: item.barcode,
        label: item.barcode,
    }))
    const getAllUniqueID = preprocessingQueueData.filter((data) => data.barcode != null).map((item) => ({
        value: item.box_unique_id,
        label: item.box_unique_id,
    }))


    const onSelectChange = (newSelectedRowKeys, newRow) => {
        setSelectedRowKeys(newRow);
    };
    const rowSelection = {
        onChange: onSelectChange,

        getCheckboxProps: record => ({
            disabled: record.is_moved == 1, // Example: disable row based on data
        }),
    };
    const handleSaveData = (values, actionType) => {
        console.log(values, "values===");

        const isPagination = actionType === "pagination";
        let currentData, originalDataRef;
        if (activetab === '1') {
            currentData = preprocessingQueueData;
            originalDataRef = originalData;
        } else if (activetab === '2') {
            currentData = completedPreprocessingQueueData;
            originalDataRef = completedOrginalData;
        } else {
            toast.error("Invalid tab selection!");
            return;
        }

        // if (originalData.length == 0 || !preprocessingQueueData.length) {
        //     toast.error("No data to save!");
        //     return;
        // }
        const parsedOriginalData = JSON.parse(originalDataRef);
        const updatedData = currentData.filter((item) => {
            const originalItem = parsedOriginalData.find((orig) => orig.key === item.key);
            return originalItem && JSON.stringify(originalItem) !== JSON.stringify(item);
        });
        if (updatedData.length === 0 && !isProcessModalOpen) {
            if (!isPagination) toast.info("No changes detected.");
            return;
        }

        const modifiedData = updatedData.filter((item) => modifiedRows.has(item.key));
        const invalidRows = modifiedData.filter(
            (item) =>
                item.spec &&
                (item.description == null || item.description == "" || item.from == null || item.from == "" || item.to == null || item.to == "")
        );
        console.log(invalidRows, "invalidRows===");

        if (invalidRows.length > 0) {
            toast.error("Description, From, and To are required when Spec ID is selected!");
            return;
        }
        let specLabel = null;
        if (values.spec) {
            const foundSpec = jobData.find((item) => item.id === values.spec);
            specLabel = foundSpec ? foundSpec.spec_id : values.spec;
        }


        const formattedModalData = isProcessModalOpen
            ? [
                {
                    ...selectedRecord,
                    ...values,
                    spec: specLabel,

                },
            ]
            : [];
        const postData = {
            updatedData: isProcessModalOpen ? formattedModalData : modifiedData,
            customer_id: preprocessingQueueData[0]?.customer_id,
            assign_user_id: userId,
            prep_queue_id: atob(id),
            activetab: activetab,
            updated_user_id: Number(localStorage.getItem('user_id'))
        }
        console.log(postData, "postData===");

        dispatch(updateWeareHouseData({ postData }))
            .unwrap() // Handle the promise returned by the thunk
            .then(() => {
                window.location.reload();
                // On successful save, re-fetch the updated data
                const editId = atob(id);
                const assign_user_id = localStorage.getItem('user_id');
                dispatch(weareHouseById({ editId, assign_user_id }))
                    .then(() => {
                        toast.success("Data saved successfully!");
                        setModifiedRows(new Set());
                    });
            })
            .catch((error) => {
                toast.error("Please Select Spec ID ")
            });

    };
    const handleDeleteUniueID = () => {
        if (selectedRowKeys.length === 0) {
            toast.dismiss()
            return toast.error("Please select at least one row");
        }

        // SweetAlert confirmation
        Swal.fire({
            title: "Are you sure?",
            text: "This will permanently delete the selected Box Unique IDs.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        }).then((result) => {
            if (result.isConfirmed) {
                // Prepare data for API
                const data = selectedRowKeys.map((item) => ({
                    box_unique_id: item.box_unique_id,
                    ...(activetab === "2" && { barcode: item.barcode }), // include only for tab 2
                }));

                const postData = {
                    ...data,
                    activetab,
                };

                // Dispatch delete action
                dispatch(deleteBoxUniqueIDWeareHouseData({ postData }));

                // Swal.fire("Deleted!", "The selected items have been deleted.", "success");
            }
        });
    };
    const handleClose = () => {
        setFileModal(false)
    }
    const fileTypeColumns = [
        {
            title: "Serial No",
            dataIndex: "file_type", // Ensure the correct key
            key: "file_type",
            render: (_, record, index) => index + 1,
            align: "center",
        },
        {
            title: "File Type",
            dataIndex: "file_type", // Ensure the correct key
            key: "file_type",
            align: "center",
        },
        {
            title: "Action",
            key: "action",
            render: (data) => (
                <>
                    <Tooltip title="Edit">
                        <Button
                            shape="circle"
                            className="border-0"
                            icon={<EditOutlined style={{ color: "blue" }} />}

                            onClick={() => {
                                setEditingFileType(data);
                                setIsEditingFile(true);
                                setAddFileModal(true);
                                setFileValue("file_type", data.file_type); // Pre-populate the form
                            }}
                        />

                    </Tooltip>
                </>

            ),
        }
    ]
    const handleFilterChange = (payload = {}) => {
        const editId = window.atob(id);
        dispatch(weareHouseById({ editId, uniqueIdStartValue, uniqueIdEndValue, barocdestartvalue, barocdeendvalue, ...payload }));
        setSearchModal(false);
        setBarocdestartvalue(null);
        setBarocdeendvalue(null);
        setUniqueIdStartValue(null);
        setUniqueIdEndValue(null);
        setClearData(true);


    };

    const clearFilterData = () => {
        setClearData(false);
        setBarocdestartvalue(null);
        setBarocdeendvalue(null);
        setUniqueIdStartValue(null);
        setUniqueIdEndValue(null);
        getData({});

    }

    const inputRef = useRef(null);
    const handleAddFileSubmit = () => {
        handleFileSubmit(onSubmitFile)();
        rest();
    };
    const handleTabChange = (key) => {
        navigate(`?tab=${key}`);
        window.location.reload(); //
    };

    // 
    useEffect(() => {
        const urlTab = params1.get("tab");
        if (urlTab) {
            setActiveTab(urlTab);
        }
    }, [location.search]);
    return (
        <>
            <Loader loading={weareHouseLoading} />
            {/* <Loader loading={prepTeamQueueLoading} /> */}
            <PageHeader
                HeaderText="Review and Assign Spec"
                Breadcrumb={[{ name: "Review and Assign Spec" }]}

            />
            {/* Wrap Tabs + top buttons in Flex */}
            <Flex justify="space-between" align="center" style={{ marginBottom: 10, flexWrap: "wrap" }}>
                <Tabs
                    activeKey={activetab}
                    defaultActiveKey="1"
                    onChange={handleTabChange}
                    type="card"
                >
                    <TabPane style={{ marginRight: "50px", }} tab="Awaiting Review Boxes" key="1" />
                    <TabPane tab="Spec Assigned Boxes" key="2" />
                </Tabs>

                {/* Right side buttons in same line as tabs */}
                <Flex align="center" style={{ gap: "10px", marginRight: '50px', flexWrap: "wrap" }}>
                    <Button
                        style={{ backgroundColor: '#1e90a9' }}
                        shape="round"
                        type="primary"
                        icon={<PrinterOutlined />}
                        onClick={handleDownloadUniqueIDLabel}
                    >
                        Export Unique ID Label
                    </Button>
                    <Button
                        style={{ backgroundColor: '#da7e22ff' }}
                        shape="round"
                        type="primary"
                        icon={<DownloadOutlined />}
                        onClick={handleDownloadExcel}
                    >
                        Download Template
                    </Button>
                    <Button
                        style={{ backgroundColor: '#7e0e0eff' }}
                        shape="round"
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={showModal}
                    >
                        Upload Excel
                    </Button>
                    {/* {role_id != 3 && (
                        <Button
                            className="primary-btn rounded-5"
                            onClick={() => setFileModal(true)}
                        >
                            Document File Types
                        </Button>
                    )} */}

                </Flex>
            </Flex>

            {/* Line 2: Save + Search */}
            <Flex align="center" style={{ gap: "10px", marginBottom: 20, marginLeft: '10px', flexWrap: "wrap" }}>
                <SearchComponent
                    style={{ width: "200px" }}
                    placeHolder="Search Unique ID"
                    onChange={(e) => getData({ query: e.target.value })}
                />
                <Button
                    style={{ backgroundColor: "green", color: "white" }}
                    shape="round"
                    type="default"
                    icon={<SaveOutlined />}
                    onClick={handleSaveData}
                >
                    Save
                </Button>
                <Button icon={<SearchOutlined />} className="primary-btn ml-2" shape="round" type="primary mr-3" onClick={() => setSearchModal(true)} >Search Filter</Button>
                {clearData && (
                    <Button
                        className="btn-danger"
                        shape="round"
                        icon={<ReloadOutlined />}
                        onClick={clearFilterData}
                    >
                        Clear Filters
                    </Button>
                )}

                <Button
                    style={{ backgroundColor: "red", color: "white" }}
                    shape="round"
                    type="default"
                    icon={<DeleteOutlined />}
                    onClick={handleDeleteUniueID}
                >
                    Delete  Unique ID Boxes
                </Button>
                <Button
                    className='primary-btn'
                    // style={{ backgroundColor: "red", color: "white" }}
                    shape="round"
                    type="default"
                    icon={<EyeFilled />}
                    onClick={() => setDeleteModalVisible(true)}
                >
                    View Deleted Unique ID Boxes
                </Button>
            </Flex>

            {/* Tab content */}
            <Tabs
                activeKey={activetab}
                onChange={(key) => setActiveTab(key)}
                renderTabBar={() => <></>} // hide duplicate tab headers
            >
                <TabPane key="1">
                    {/* Awaiting Review content */}
                    <Card >
                        {
                            awaitingReviewBoxesData?.data?.length > 0 ?
                                (
                                    <Form form={form} component={false}>
                                        <TableComponent style={{ marginTop: '-20px' }}
                                            rowSelection={rowSelection}
                                            dataSource={activetab == '1' ? preprocessingQueueData : completedPreprocessingQueueData}
                                            columns={columns}
                                            onChangeDispatch={(payload) => {
                                                getData(payload);
                                                handleSaveData(payload, "pagination");

                                            }}
                                        />
                                    </Form>
                                ) : (
                                    <>
                                        <TableComponent
                                            rowSelection={rowSelection}

                                            columns={columns}
                                        />
                                    </>
                                )
                        }
                    </Card>
                </TabPane>
                <TabPane key="2">
                    {/* Spec Assigned content */}
                    <Card >
                        {
                            specAssignedBoxesData?.data?.length > 0 ?
                                (
                                    <Form form={form} component={false}>
                                        <TableComponent
                                            rowSelection={rowSelection}
                                            dataSource={activetab == '2' ? completedPreprocessingQueueData : preprocessingQueueData}
                                            columns={columns}
                                            onChangeDispatch={getData}
                                        />
                                    </Form>
                                ) : (
                                    <TableComponent
                                        rowSelection={rowSelection}

                                        columns={columns}
                                    />
                                )
                        }
                    </Card>
                </TabPane>
            </Tabs>
            <Modal
                open={fileModal}
                onCancel={handleClose}
                width={700}
                footer={null}
            >
                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
                    <Button className="primary-btn" onClick={() => {
                        setAddFileModal(true);
                    }}>
                        Add File Type
                    </Button>
                </div>

                <TableComponent columns={role_id == 1 || role_id == 2 ? fileTypeColumns : ""} dataSource={tableFileData} TotalDataCount={counts} size={"small"} onChangeDispatch={getData} />

            </Modal>

            <Modal title="Upload Excel File" open={isModalOpen} onOk={handleUpload} onCancel={handleCancel} okText="Upload">
                <Upload
                    beforeUpload={(file) => {
                        setFileList([file]);
                        return false;
                    }}
                    fileList={fileList}
                    accept=".xlsx, .xls"
                >
                    <Button icon={<UploadOutlined />}>Select Excel File</Button>
                </Upload>
            </Modal>
            <Modal
                open={searchModal}
                onCancel={() => setSearchModal(false)}
                // footer={null}
                onOk={handleSearch}
                okText="Search"
                title={
                    <span>
                        Search Filter <SearchOutlined style={{ marginRight: 6 }} />
                        <hr />
                    </span>

                }
                width={600}
            >

                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', }}>

                    {/* First Line: Spec or Customer Name */}
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label style={{ marginBottom: '6px', fontWeight: 'bold' }}>Search by Spec or Customer</label>
                        <Input
                            placeholder="Enter Spec or Customer Name"
                            value={searchText}
                            onChange={(e) => setSearchText(e.target.value)}
                        />
                    </div>

                    {/* Second Line: Pickup Date */}
                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <label style={{ marginBottom: '6px', fontWeight: 'bold' }}>Pickup Date</label>
                        <DatePicker
                            style={{ width: '100%' }}
                            placeholder="Select Pickup Date"
                            value={searchDate}
                            onChange={(date) => setSearchDate(date)}
                            format="MM/DD/YYYY"
                        />
                    </div>

                </div>

            </Modal>
            {weareHouseLoading ? <Loader /> : <>
                <Modal
                    title="Upload in Progress"
                    open={uploadModalVisible}
                    footer={[
                        <Button key="logs" type="primary" className='primary-btn' onClick={() => navigate("/upload-log", { state: { activeTab: "warehouse" } })}>
                            Go to Upload Logs
                        </Button>,
                    ]}
                    onCancel={() => setUploadModalVisible(false)}
                >
                    <p>Data upload is in progress. Please check upload logs.</p>
                </Modal>
            </>}

            <Modal
                title={
                    <div style={{ textAlign: "center" }}>
                        <Title level={4} style={{ marginBottom: 0 }}>
                            Process Box - {selectedRecord?.box_unique_id || "N/A"}
                        </Title>
                        <Text type="secondary">Review and update details before saving</Text>
                    </div>
                }
                open={isProcessModalOpen}
                onCancel={() => {
                    setIsProcessModalOpen(false)
                    form.resetFields()
                }}
                onOk={() => form.submit()} // use Form submit for validation
                okText="Save Changes"
                cancelText="Cancel"
                width={1000}
                style={{ top: 30 }}
                styles={{ body: { backgroundColor: "#fafafa", borderRadius: "8px", padding: "24px" } }}
            >
                {selectedRecord && (
                    <Form
                        form={form}
                        layout="vertical"
                        initialValues={{
                            box_unique_id: selectedRecord.box_unique_id,
                            customer_name: selectedRecord.customer_name,
                            spec: selectedRecord.spec,
                            from: selectedRecord.from,
                            to: selectedRecord.to,
                            box: selectedRecord.box,
                            alt_box: selectedRecord.alt_box,
                            barcode: selectedRecord.barcode,
                            printed_name: selectedRecord.printed_name,
                            date_in: selectedRecord.date_in
                                ? dayjs(selectedRecord.date_in, 'MM/DD/YYYY')
                                : null,
                            description: selectedRecord.description,
                            series_box: selectedRecord.series_box,
                            loc: selectedRecord.loc,
                            building: selectedRecord.building,
                            aisle: selectedRecord.aisle,
                            level: selectedRecord.level,
                            shelf: selectedRecord.shelf,
                        }}
                        onFinish={(values) => {
                            // Format date before passing to handleSaveData
                            const formattedValues = {
                                ...values,
                                date_in: values.date_in ? dayjs(values.date_in).format('MM/DD/YYYY') : null
                            };
                            handleSaveData(formattedValues);
                        }}
                        style={{
                            background: "#fff",
                            padding: "20px",
                            borderRadius: "8px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                            maxHeight: "70vh",
                            overflowY: "auto",
                        }}
                    >
                        {/* Box Info */}
                        {/* <Divider orientation="left" plain>
                            Box Information
                        </Divider> */}
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Box Unique ID" name="box_unique_id">
                                    <Input disabled />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Customer Name" required>
                                    <Select
                                        disabled={activetab == 2}
                                        placeholder="Select Customer Name"
                                        value={selectedRecord?.customer_id || null}
                                        options={customerLists.map((item) => ({
                                            label: item.label,
                                            value: item.value,
                                        }))}
                                        onChange={(value) => {
                                            const selectedCustomer = customerLists.find((c) => c.value === value);
                                            setSelectedRecord({
                                                ...selectedRecord,
                                                customer_id: selectedCustomer.value,
                                                customer_name: selectedCustomer.label,
                                                spec: "",     // reset spec
                                                job_id: "",   // reset job id
                                            });

                                            form.setFieldsValue({ spec: undefined });
                                        }}
                                    />
                                </Form.Item>
                            </Col>

                        </Row>

                        {/* Spec and Transfer */}
                        {/* <Divider orientation="left" plain>
                            Specification & Transfer
                        </Divider> */}
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Spec ID" name="spec">
                                    {(() => {
                                        const specOptions =
                                            jobData
                                                ?.filter((item) => item.customer_id === selectedRecord?.customer_id)
                                                ?.map((item) => ({
                                                    label: item.spec_id,
                                                    value: item.id,
                                                    workflow_id: item.workflow_id,
                                                })) || [];

                                        return (
                                            <Select
                                                showSearch
                                                optionFilterProp="label"
                                                filterOption={(input, option) =>
                                                    option.label?.toLowerCase().includes(input.toLowerCase())
                                                }
                                                disabled={activetab == 2}
                                                style={{ width: "100%" }}
                                                placeholder="Select Spec ID"
                                                options={specOptions}
                                                value={
                                                    specOptions.find((opt) => opt.label === selectedRecord?.spec)?.value ||
                                                    null
                                                }
                                                onChange={(value) => {
                                                    const selectedSpec = specOptions.find((item) => item.value === value);
                                                    console.log(selectedSpec, "selectedSpec==");

                                                    setSelectedRecord({
                                                        ...selectedRecord,
                                                        spec: selectedSpec.label,
                                                        job_id: selectedSpec.value,
                                                    });

                                                    // Update form value
                                                    form.setFieldsValue({ spec: selectedSpec.value });
                                                }}
                                            />
                                        );
                                    })()}
                                </Form.Item>
                            </Col>

                            <Col span={12}>
                                <Form.Item label="Series Box" name="series_box">
                                    <Input placeholder="Enter Series Box" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="From "
                                    name="from"
                                    required
                                    dependencies={["spec"]}
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!getFieldValue("spec") || value) return Promise.resolve();
                                                return Promise.reject(new Error("From  is required when Spec is selected"));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input placeholder="Enter From " />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="To "
                                    name="to"
                                    required
                                    dependencies={["spec"]}
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!getFieldValue("spec") || value) return Promise.resolve();
                                                return Promise.reject(new Error("To  is required when Spec is selected"));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input placeholder="Enter To " />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Description"
                                    name="description"
                                    required
                                    dependencies={["spec"]}
                                    rules={[
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!getFieldValue("spec") || value) return Promise.resolve();
                                                return Promise.reject(new Error("Description is required when Spec is selected"));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.TextArea rows={2} placeholder="Enter Description" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Box Pickup Date"
                                    name="date_in"
                                // required
                                // dependencies={["spec"]}
                                // rules={[
                                //     ({ getFieldValue }) => ({
                                //         validator(_, value) {
                                //             if (!getFieldValue("spec") || value) return Promise.resolve();
                                //             return Promise.reject(new Error("Box Pickup Date is required when Spec is selected"));
                                //         },
                                //     }),
                                // ]}
                                >
                                    <DatePicker format="MM/DD/YYYY" style={{ width: "100%" }} />
                                </Form.Item>
                            </Col>
                        </Row>
                        {/* Box & Barcode Info */}
                        {/* <Divider orientation="left" plain>
                            Box & Barcode
                        </Divider> */}
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Box" name="box">
                                    <Input disabled={true} placeholder="Enter Box ID" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Alt Box" name="alt_box">
                                    <Input disabled={true} placeholder="Enter Alternate Box" />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="Scantek Barcode" name="barcode">
                                    <Input disabled={true} placeholder="Enter Scantek Barcode" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Label Printed Name / Date" name="printed_name">
                                    <Input placeholder='Enter Label  Printed Name' />
                                </Form.Item>
                            </Col>
                        </Row>

                        {/* Description & Pickup Date */}
                        {/* <Divider orientation="left" plain>
                            Processing Details
                        </Divider> */}


                        {/* Location Details */}
                        {/* <Divider orientation="left" plain>
                            Location Details
                        </Divider> */}
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item label="LOC" name="loc">
                                    <Input placeholder="Enter Location Code" />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item label="Building / Address" name="building">
                                    <Input placeholder="Enter Building or Address" />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item label="Aisle" name="aisle">
                                    <Input placeholder="Enter Aisle" />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Level" name="level">
                                    <Input placeholder="Enter Level" />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item label="Shelf" name="shelf">
                                    <Input placeholder="Enter Shelf" />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                )}
            </Modal>

            <Modal
                open={deleteModalVisible}
                onCancel={() => setDeleteModalVisible(false)}
                footer={null}
                width={1000}
                bodyStyle={{
                    padding: "20px 24px",
                    borderRadius: "12px",
                    background: "#fafafa",
                }}
                style={{
                    borderRadius: "12px",
                }}
            >
                {/* Header Section */}
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        marginBottom: 12,
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                        <DeleteOutlined style={{ fontSize: 20, color: "#ff4d4f" }} />
                        <Title
                            level={4}
                            style={{ margin: 0, color: "#333", fontWeight: 600, letterSpacing: 0.3 }}
                        >
                            Deleted Unique ID Boxes
                        </Title>
                    </div>
                </div>

                <Divider style={{ margin: "12px 0" }} />

                {/* Table Section */}
                <div
                    style={{
                        maxHeight: 400,
                        overflowY: "auto",
                        borderRadius: "8px",
                        background: "#fff",
                        padding: "8px",
                        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                    }}
                >
                    <TableComponent
                        columns={deletedColumns}
                        dataSource={deletedTableData}
                        TotalDataCount={deletedCounts}
                    />
                </div>
            </Modal>;
        </>
    );
};

export default ReviewAndAssignSpec;